let userLang = null;

try{
    userLang = localStorage.getItem('language.selected');
}catch(e){}

if(userLang === null || userLang === undefined){
    userLang = navigator.language.substr(0,2);
}

let availableLanguages = [
    {
        id: 3,
        code: "en",
        name: 'English',
        flag_img_path: '/img/flags/en.png',
        dateTimeFormat: {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
        },
        numberFormat: {
            currency: {
                style: 'currency'
            }
        }
    },
    {
        id: 1,
        name: 'Español',
        code: "es",
        flag_img_path: '/img/flags/es.png',
        dateTimeFormat: {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
        },
        numberFormat: {
            currency: {
                style: 'currency'
            }
        }
    },
    {
        id: 2,
        name: 'Português',
        code: "pt",
        flag_img_path: '/img/flags/br.png',
        dateTimeFormat: {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
        },
        numberFormat: {
            currency: {
                style: 'currency'
            }
        }
    },
    {
        id: 4,
        name: 'Türkçe',
        code: "tr",
        flag_img_path: '/img/flags/tr.png',
        dateTimeFormat: {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
        },
        numberFormat: {
            currency: {
                style: 'currency'
            }
        }
    },
];

let index = availableLanguages.findIndex((element) => element.code === userLang);

if (index === -1) {
    switch (userLang) {
        case 'it':
            index = 1;
            break;
        default:
            index = 0;
            break;
    }
}

let temp = availableLanguages[0];
availableLanguages[0] = availableLanguages[index];
availableLanguages[index] = temp;

export default availableLanguages;